import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddOfficeHour from "../../../containers/admin/office-hours/models/add-office-hour";
import SearchBar from "../../../containers/admin/office-hours/searchbar";
import OfficeHoursTable from "../../../containers/admin/office-hours/table";
import { getOfficeHoursRequest } from "../../../modules/admin-modules/office_hours/Actions";

const OfficeHoursPage = () => {
  const dispatch = useDispatch();
  const officeHours = useSelector((state) => state.officeHours.officeHours);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getOfficeHoursRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        officeHours={officeHours}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <OfficeHoursTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddOfficeHour
        key={`office-hour-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default OfficeHoursPage;
